import { useMemo } from "react";

export const useMemos = (propsListData) => {
  const listingData = useMemo(() => ({...propsListData}), [propsListData]) 
 
  const agents = useMemo(() => listingData.team_member_incomes.incomes, [listingData.team_member_incomes.incomes]);

  return { listingData, agents }
}
